import { ActionTree } from "vuex";
import { baseApi } from "@/config/http-common";
import { IRootState } from "@/store";
import { ICompanyState } from "@/store/modules/company/state";
import { CompanyMutations } from "@/store/modules/company/mutations";

export enum CompanyActions {
  FETCH_DATA_PROVIDER = "FETCH_DATA_PROVIDER_COMPANY",
  FETCH_ONE = "FETCH_ONE_COMPANY",
  FETCH_ALL = "FETCH_ALL_COMPANY",
  CREATE = "CREATE_COMPANY",
  UPDATE = "UPDATE_COMPANY",
  DELETE = "DELETE_COMPANY",
  DELETE_ALL = "DELETE_ALL_COMPANY",
  FETCH_PARENTS = "FETCH_PARENTS",
}

export const actions: ActionTree<ICompanyState, IRootState> = {
  async [CompanyActions.FETCH_DATA_PROVIDER]({ commit }, params) {
    try {
      const result = await baseApi.get("/users/companies/list", {
        params: params,
      });
      commit(CompanyMutations.SET_LAZY_DATA, result.data.data);
    } catch (error) {
      console.log("get company data provider error: ", error);
    }
  },
  async [CompanyActions.FETCH_ONE]({ commit }, id) {
    try {
      const result = await baseApi.get(`/users/companies/view/${id}`);
      commit(CompanyMutations.SET_ONE, result.data.data);
    } catch (error) {
      console.log("fetch company one error: ", error);
    }
  },
  async [CompanyActions.FETCH_ALL]({ commit }) {
    try {
      const result = await baseApi.get("/users/users/sub-data/companies");
      commit(CompanyMutations.SET_ALL, result.data.data);
    } catch (error) {
      console.log("fetch company one error: ", error);
    }
  },
  async [CompanyActions.CREATE]({ commit }, data: Document) {
    return new Promise((resolve, reject) => {
      baseApi
        .post("/users/companies/create", data)
        .then((data) => {
          commit(CompanyMutations.SET_ONE, data);
          resolve(true);
        })
        .catch((error) => {
          console.log("user create error: ", error);
          reject(error.response);
        });
    });
  },
  async [CompanyActions.UPDATE]({ commit }, { id, data }) {
    return new Promise((resolve, reject) => {
      baseApi
        .put(`/users/companies/update/${id}`, data)
        .then((data) => {
          commit(CompanyMutations.SET_ONE, data);
          resolve(true);
        })
        .catch((error) => {
          console.log("company update error: ", error);
          reject(error.response);
        });
    });
  },
  async [CompanyActions.DELETE](
    { commit },
    payload: string | { id: string; coordinatorId?: string }
  ) {
    const id = typeof payload === "string" ? payload : payload.id;
    const coordinatorId =
      typeof payload === "object" ? payload.coordinatorId : undefined;
    try {
      await baseApi.delete(`/users/companies/delete/${id}`, {
        params: coordinatorId != null ? { coordinatorId } : undefined,
      });
    } catch (error) {
      console.log("company delete error:", error);
      throw error;
    }
  },
  async [CompanyActions.DELETE_ALL]({ commit }) {
    try {
      await baseApi.delete(`/companies`);
      commit(CompanyMutations.SET_ALL, []);
    } catch (error) {
      console.log("company delete all", error);
    }
  },
  async [CompanyActions.FETCH_PARENTS]({ commit }) {
    try {
      const result = await baseApi.get("/users/companies/parents/list");
      commit(CompanyMutations.SET_ALL, result.data.data);
    } catch (error) {
      console.log("company fetch parents", error);
    }
  },
};
